angular.module('gym.templates').controller('EditTemplateCtrl', ["$scope", "$state", "$rootScope", "$http", "flash", "EmploymentService", "SmsValidationService", "PushNotificationValidationService", "TemplateSanitizeService", "Templates", "PingService", "GTMService", "TestEmailsService", "template", function($scope, $state, $rootScope, $http, flash, EmploymentService, SmsValidationService, PushNotificationValidationService, TemplateSanitizeService, Templates, PingService, GTMService, TestEmailsService, template) {
  var save, trackPage;
  $scope.template = template;
  $scope.pageTitle = template.id ? 'Edit Template' : 'New Template';
  $scope.gym = $rootScope.gym;
  $scope.sequencesEnabled = $rootScope.gym.sequences_enabled;
  $scope.customHeadTagEnabled = $rootScope.gym.gym_config.can_set_email_template_head_tag;
  trackPage = template.id ? 'Message Tempates - Edit' : 'Message Tempates - Add';
  save = function() {
    if (template.id) {
      return $http.put(`/gyms/${$rootScope.gym.id}/templates/${template.id}`, {
        template: template
      });
    } else {
      return $http.post(`/gyms/${$rootScope.gym.id}/templates`, {
        template: template
      });
    }
  };
  $scope.save = function() {
    GTMService.trackPage(trackPage, 'attempt');
    template = TemplateSanitizeService.sanitize($scope.template);
    return save(template).then(function() {
      GTMService.trackPage(trackPage, 'success');
      $state.go('gym.templates.list');
      if (template.id) {
        return flash.success = "Template updated successfully";
      } else {
        return flash.success = "Template created successfully";
      }
    }, function(response) {
      var ref, ref1, ref2, ref3;
      GTMService.trackPage(trackPage, 'error');
      flash.error = "There was an error processing the request.";
      return $scope.errorMessage = (ref = response.data.data) != null ? (ref1 = ref.attributes) != null ? (ref2 = ref1.errors) != null ? (ref3 = ref2.content) != null ? ref3[0] : void 0 : void 0 : void 0 : void 0;
    });
  };
  $scope.templateReady = function() {
    $scope.error = SmsValidationService.getErrors($scope.template);
    if ($scope.template.channel === 'email') {
      return !$scope.error && $scope.template.name && $scope.template.subject && $scope.template.content;
    } else if ($scope.template.channel === 'push_notification') {
      return !$scope.error && $scope.template.name && $scope.template.subject && $scope.template.content && PushNotificationValidationService.isLengthValid($scope.template.content);
    } else {
      return !$scope.error && $scope.template.name && $scope.template.content && SmsValidationService.isLengthValid($scope.template.content);
    }
  };
  $scope.testEmailReady = function() {
    return $scope.template.subject && $scope.template.content;
  };
  $scope.isTemplateDisabled = function() {
    return $scope.template.role === 'mobile_app_invite_prompt' && !$scope.gym.custom_emails_enabled;
  };
  return $scope.sendTestEmail = function() {
    var params;
    params = {
      subject: $scope.template.subject,
      content: $scope.template.content,
      head_tag_content: $scope.template.head_tag_content,
      reply_address: window.currentUser.email
    };
    return TestEmailsService.sendTestEmail(params);
  };
}]);
